import { render, staticRenderFns } from "./QuestionCircleIcon.vue?vue&type=template&id=51284df0&"
import script from "./QuestionCircleIcon.vue?vue&type=script&lang=js&"
export * from "./QuestionCircleIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports